import { render, staticRenderFns } from "./huizong_table.vue?vue&type=template&id=56558f55&scoped=true"
import script from "./huizong_table.vue?vue&type=script&lang=js"
export * from "./huizong_table.vue?vue&type=script&lang=js"
import style0 from "./huizong_table.vue?vue&type=style&index=0&id=56558f55&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56558f55",
  null
  
)

export default component.exports